import { where } from "firebase/firestore"
import { getCliente, getEstacionamento, getRevendaIdByPark, getUsuario, isAdministrador } from '../../config/auth'
import { Collection } from '../../shared/constants'
import { isNullOrEmpty } from '../../shared/utils'
import { addDoc, getAllDocsByRevendaId, getDocByParkId, getDocByQueries, updateDoc } from './collectionBaseWorker'

export const saveLastUpdate = async (estacionamentoId) => {
    const park = {
        id: estacionamentoId ?? getEstacionamento().id,
        clienteId: getCliente().id,
    }
    await saveLastUpdateByPark(park, true)
}

export const saveLastUpdateNoSkip = async () => {
    const park = {
        id: getEstacionamento().id,
        clienteId: getCliente().id,
    }
    await saveLastUpdateByPark(park, false)
}

export const saveLastUpdateByPark = async (park, canSkip) => {
    const estacionamentoId = park.id
    const clienteId = park.clienteId
    const user = isAdministrador() === false ? getUsuario() : { email: "automação@site.com.br", nome: "Automação" }
    const item = await getDocByQueries({
        collection: Collection.LAST_UPDATE,
        queries: [
            where(Collection.LAST_UPDATE, '==', estacionamentoId),
        ]
    })
    if (isNullOrEmpty(item)) {
        const data = {
            clienteId: clienteId,
            estacionamentoId: estacionamentoId,
            revendaId: getRevendaIdByPark(),
            park: park,
            lastUpdate: new Date(),
            canSkip: canSkip,
            alterBy: {
                email: user.email,
                name: user.nome
            }
        }
        await addDoc({ collection: Collection.LAST_UPDATE, data: data })
    } else {
        const data = {
            lastUpdate: new Date(),
            park: park,
            deviceIdentifier: null,
            canSkip: canSkip,
            alterBy: {
                email: user.email,
                name: user.nome
            }
        }
        await updateDoc({ collection: Collection.LAST_UPDATE, id: item.id, data: data })
    }
}

export const getLastUpdateByParkId = async ({ estacionamentoId }) => {
    return await getDocByParkId({ collection: Collection.LAST_UPDATE, estacionamentoId: estacionamentoId })
}

export const getAllLastUpdateByRevendaId = async ({ revendaId }) => {
    return await getAllDocsByRevendaId({ collection: Collection.LAST_UPDATE, revendaId: revendaId })
}